export const PROPERTY_TYPE_GROUPS = 'GROUPS';
export const PROPERTY_TYPE_BRANDS = 'BRANDS';
export const PROPERTY_TYPE_HOTELS = 'HOTELS';

export const FILTER_TYPE_GROUP = 'GROUP';
export const FILTER_TYPE_BRAND = 'BRAND';
export const FILTER_TYPE_HOTEL = 'HOTEL';

export const GROUP_CREATE = 'group_create';
export const GROUP_EDIT = 'group_edit';
export const GROUP_VIEW = 'group_view';
export const BRAND_CREATE = 'brand_create';
export const BRAND_EDIT = 'brand_edit';
export const BRAND_VIEW = 'brand_view';
export const HOTEL_CREATE = 'hotel_create';
export const HOTEL_EDIT = 'hotel_edit';
export const HOTEL_VIEW = 'hotel_view';

export const TravelTypes = ['Business', 'Leisure', 'Getaway', 'Family', 'Couples'];
export const Interests = [
  'Food',
  'Shopping',
  'Wellness',
  'Activity',
  'Culture',
  'Restaurants & Bars',
];
export const StarRatings = ['2', '3', '4', '5', '7'];

export const ASSET_TYPE_PROPERTY = 'properties';
export const ASSET_TYPE_DOC = 'docs';
export const ASSET_TYPE_RESERVATION_DOC = 'reservation_docs';
export const ASSET_TYPE_PROPERTY_UI_BUILDER = 'property_ui_builder';

export const ASSET_BRANDS = 'brands';
export const ASSET_HOTELS = 'hotels';
export const ASSET_ROOM_TYPES = 'room_types';
export const ASSET_PACKAGES = 'packages';

export const HOTEL_VIEW_TAB_LIST = [
  'Details',
  'Location',
  'Documents',
  'Information',
  'Features',
  'WC Message',
  'Media',
];
export const BRAND_VIEW_TAB_LIST = ['Details', 'Media'];

export const HOTEL_INFO_TYPES = [
  {
    text: 'Email',
    value: 'EMAIL',
    title: 'Add Email Title',
    valueType: 'Email',
  },
  {
    text: 'URL',
    value: 'URL',
    title: 'Add URL Title',
    valueType: 'URL',
  },
  {
    text: 'Phone Number',
    value: 'PHONE',
    title: 'Add Phone Number Title',
    valueType: 'Phone',
  },
  {
    text: 'Social Media',
    value: 'SOCIAL_MEDIA',
    title: 'Social Media Title (Ex: Instagram / Facebook)',
    valueType: 'URL',
  },
];

export const WC_MESSAGE_STATUS = ['Active', 'Inactive'];

export const HOTEL_REGION_OPTIONS = [
  { name: 'Frankfurt', code: 'eu-central-1' },
  { name: 'Oregon', code: 'us-west-2' },
  { name: 'UAE', code: 'me-central-1' },
  { name: 'Mumbai', code: 'ap-south-1' },
];
